module.exports = __webpack_public_path__ + "static/img/china-top.9bacdde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-top.png
// module id = 1390
// module chunks = 1